import { render, staticRenderFns } from "./VideoFormGeneration.vue?vue&type=template&id=4deee175&scoped=true&"
import script from "./VideoFormGeneration.vue?vue&type=script&lang=js&"
export * from "./VideoFormGeneration.vue?vue&type=script&lang=js&"
import style0 from "./VideoFormGeneration.vue?vue&type=style&index=0&id=4deee175&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4deee175",
  null
  
)

export default component.exports